import { Box, Typography } from '@mui/material';
import { Section } from './Section';
import { WHY } from './copy';

const HEADING_ID = 'why-title';

export function WhyStorefront() {
  return (
    <Section labelledBy={HEADING_ID} title={WHY.title}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          rowGap: 4,
        }}
      >
        {WHY.columns.map((column, i) => (
          <Box
            key={column.title}
            sx={{
              pl: { xs: 0, md: i === 0 ? 0 : 4 },
              pr: { xs: 0, md: i === WHY.columns.length - 1 ? 0 : 4 },
              borderLeft: { xs: 'none', md: i === 0 ? 'none' : '1px solid var(--rule)' },
            }}
          >
            <Typography variant="h4" component="h3" sx={{ mb: 1 }}>
              {column.title}
            </Typography>
            <Typography sx={{ color: 'var(--ink-muted)', maxWidth: '44ch' }}>
              {column.body}
            </Typography>
          </Box>
        ))}
      </Box>

      <Typography
        variant="h3"
        component="p"
        sx={{ mt: { xs: 5, md: 7 }, fontStyle: 'italic', color: 'var(--ink)' }}
      >
        {WHY.closing}
      </Typography>
    </Section>
  );
}
